function queryHandler(opts) {
  let {
    apollo,
    component,
    query,
    queryOpts,
    onSucecss,
    onError,
    onErrors
  } = opts

  apollo.query(queryOpts)
    .then( (response) => {
      responseHandler({
        ...response,
        ...opts
      })
    })
    .catch( (error) => {
      errorHandler({
        error: error,
        ...opts
      })
    })
}

function responseHandler(opts) {
  let {
    data,
    errors,
    onErrors,
    onSuccess,
    component,
    query
  } = opts

  console.info(opts)

  if (errors === undefined || errors === []) {
    console.log("Cardstock: " + component + " succeeded at " + query)
    onSuccess(data)
  } else {
    console.log("Cardstock: " + component + " failed handleable attempting " + query + " with errors: " + JSON.stringify(errors))
    onErrors(errors.map(error => error["message"]))
  }
}

function errorHandler(opts) {
  let {
    error,
    component,
    query,
    onError
  } = opts

  console.error("Cardstock: " + component + " failed unhandleable attempting " + query + " with error: " + JSON.stringify(error))
  onError(translateError(error.message))
}

function translateError(error) {
  switch(error) {
    case "Network error: Failed to fetch":
      return "A network error occurred"
    default:
      return "An unexpected error occurred"
  }
}

export { responseHandler, errorHandler, queryHandler }
